import 'jquery-zoom';

function initProductImageZoom() {
  if ($(window).width() > 767) {
    // $('.product__slider .product__image-container')
    // .zoom({
    //   touch: true,
    //   magnify: 1.5,
    // });

    $(window).trigger('resize');
  }
}

initProductImageZoom();
